import type { PermissionRequirement } from '~/utils/rbac'
import type { PermissionTuple } from '~/utils/ability'

/** Lire l'écran : les mêmes droits que la route `GET /inventories/overview` (l'un OU l'autre). */
export const INVENTORIES_READ: PermissionRequirement = {
  any: [
    ['read', 'stores.all-inventories.history'],
    ['read', 'stores.current-inventory.inventory'],
  ],
}

/** Valider ou refuser un lot défectueux retenu : une seule action spéciale (kanban #823). */
export const DEFECTIVE_BATCH_VALIDATE: PermissionTuple = [
  'validate-defective-batch',
  'stores.defective-batches.validation',
]
